import React, { useCallback } from "react";
import { Col, Row } from "antd";
import { useSelector } from "react-redux";
import styles from "./groupControls.scss";
import Control from "./Control";
import { CategoryName, ControlType, InputType, LocalStorageKey, ModuleName } from "../../../../models";
import {
  getWindowWidth,
  isSearchMobile,
  localStorage
} from "../../../../services";
import { ConditionEvaluator } from "../../../../utils/conditionEvaluator";
import { selectAdData } from "../../../../routes/AdForm/adForm.ducks";
import { selectUserInfo } from "../../../../routes/Auth/auth.ducks";
import { mapCategoryToEn, mapModuleToEn } from "../../../../routes/LanguageMapper";

// Polja koja se prikazuju samo poslovnim korisnicima. Physical users
// (legalEntity !== true) su ih vidjeli bez svrhe i zbunjivalo ih je.
const LEGAL_ENTITY_ONLY_FIELDS = ["propertyCode"];

const GroupControls = props => {
  const { controls, form, isFullWidth, match, setIsValidating, fieldConditions } = props;
  const selectedData = useSelector(selectAdData);
  const user = useSelector(selectUserInfo);
  const isLegalEntity = !!(user && user["legalEntity"]);
  const isCar =
    !!selectedData &&
    !!selectedData.module &&
    !!selectedData.category &&
    mapModuleToEn(selectedData.module) === ModuleName.vehicles &&
    mapCategoryToEn(selectedData.category, mapModuleToEn(selectedData.module)) === CategoryName.car;
  const beFullWidth = useCallback(group => {
    if (
      group.type == ControlType.photoUploader ||
      group.type == ControlType.tyres ||
      (group.type == ControlType.multiFieldSelectorCb &&
        group.options.length > 2) ||
      group.type == ControlType.multiLevel ||
      group.type == ControlType.suggestedTitle ||
      group.type == ControlType.suggestedAITitle ||
      group.type == ControlType.suggestedTitle ||
      // InputTextList (V2OGLASI-2645) needs full row so the trash icon
      // can float into the group container's right padding (Tyres pattern).
      group.type == ControlType.inputTextList ||
      // Area multi-select (V2OGLASI-2648) hosts an Antd multi-select with
      // chips that need the full row width.
      group.type == ControlType.locationMultiSelect
    ) {
      return true;
    }
    if (group.field == "videoUrl" || group.field == "description" || group.field == "aboutEmployer" || group.field == "exchangeDescription") {
      return true;
    }
    return false;
  }, []);

  const isMobile = isSearchMobile(getWindowWidth());

  const returnWidth = useCallback(group => {
    if (
      group.type == ControlType.multiFieldSelectorCb &&
      group.options.length == 2
    ) {
      return 16;
    }
    if (group.type == ControlType.radioSelector) {
      if (group.field == "locationScope") return 24;
      return isCar ? 24 : 16;
    }
    if (isCar && group.field == "price") {
      return 16;
    }
    return 8;
  }, [isCar]);

  return (
    <React.Fragment>
      <Row type="flex" className={styles.container}>
        {controls.map((control, index) => {
          const hasVisibleGroups = control.groups.some((group) => {
            if (!group.condition) return true;
            const currentData = localStorage.getItem(LocalStorageKey.savedForm);
            return ConditionEvaluator.evaluateCondition(group.condition, currentData || {});
          });

          return (
          <React.Fragment key={index}>
            {hasVisibleGroups && (
            <div className={styles.title}>
              {control.name ? (
                <span className={styles.controlTitle}>{control.name}</span>
              ) : null}
              {control.description && (
                <p className={styles.description}>{control.description}</p>
              )}
            </div>
            )}
            <Row gutter={16} style={{ width: "100%", margin: "0" }} type="flex">
              {control.groups.map((group, i) => {
                const {
                  condition,
                  marginTop,
                  type
                } = group;

                if (
                  !isLegalEntity &&
                  LEGAL_ENTITY_ONLY_FIELDS.indexOf(group.field) !== -1
                ) {
                  return null;
                }

                // Read once and share between the two visibility checks
                // below — localStorage.getItem parses JSON so this is a
                // live object of the current form state.
                const currentFormData = (condition || group.scopeField)
                  ? localStorage.getItem(LocalStorageKey.savedForm)
                  : null;

                // Check if field should be hidden based on condition
                if (condition) {
                  if (!ConditionEvaluator.evaluateCondition(condition, currentFormData || {})) {
                    return null;
                  }
                }

                // V2OGLASI-2648: the exact-location MultiLevel ships with
                // `scopeField: "locationScope"` on jobs/services forms. Hide
                // it when the picked scope is anything other than Exact (1),
                // so wider-area ads don't force a city-level entry.
                if (group.scopeField && group.type == ControlType.multiLevel) {
                  const scopeValue = currentFormData && currentFormData[group.scopeField];
                  if (scopeValue && scopeValue !== 1) {
                    return null;
                  }
                }

                return beFullWidth(group) ? (
                  <Col xs={24} key={i} style={{
                    margin: 0,
                    minHeight: `${group.valueType === InputType.text ? "190px" : "unset"
                      }`
                  }}>
                    <Control data={group} form={form} key={i} match={match} setIsValidating={setIsValidating} fieldConditions={fieldConditions} />
                  </Col>
                ) : (
                  <Col
                    style={{
                      display: "flex",
                      alignItems: `${group.type == ControlType.radioSelector ||
                        group.type == ControlType.multiFieldSelectorCb
                        ? "center"
                        : "flex-start"
                        }`,
                      minHeight: `${group.valueType === InputType.text ? "190px" :
                        group.type == ControlType.multiFieldSelectorCb
                          ? "unset"
                          : isMobile
                            ? "100px"
                            : "116px"
                        }`,
                      marginTop: marginTop ? marginTop : ""
                    }}
                    className={`${type}Search`}
                    xs={24}
                    md={returnWidth(group)}
                    key={i}
                  >
                    {/* {returnWidth(group)} */}
                    <Control data={group} form={form} key={i} match={match} fieldConditions={fieldConditions} />
                  </Col>
                );
              })}
            </Row>
          </React.Fragment>
        );
        })}
      </Row>
    </React.Fragment>
  );
};

export default GroupControls;



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/GroupPage/GroupControls/index.tsx